import React, { useState } from 'react';
import { useEffect } from 'react';
import { numToPrice, pexios, toast } from '../../utils/functions';
//import { numberToWords } from "@persian-tools/persian-tools";
//import { history } from '../../utils/variables';
import { toast as toast2 } from 'react-toastify';
import ZarinPal from '../../assets/images/zarinPal-1.png';
import SamanBank from '../../assets/images/saman-bank-logo.png';
import MeliBank from '../../assets/images/meli-bank-logo.png';
import Num2persian from 'num2persian';
import { useTranslation } from 'react-i18next';

export default function Payment(){
    const { t, i18n } = useTranslation();
    const [price,setPrice] = useState();
    const [selected,setSelected] = useState('');
    const [dargahSelect,setDargahSelected] = useState('')
    const constant_pay = 2937500+(2937500*0.09)
    useEffect(()=>{
        let newPrice = price 
        price && typeof price === 'string' && setPrice(newPrice.replace(/[^\d]+|^0+(?!$)/g, ''))
        numToPrice(price) === numToPrice(constant_pay) ? setSelected(0) :
        numToPrice(price) === numToPrice(constant_pay*2) ? setSelected(1) :
        numToPrice(price) === numToPrice(constant_pay*3) ? setSelected(2) : setSelected('')
    },[price])
    const handlerPay = ()=> {
        price && 
        pexios('api/request_charge_wallet','post', {cost :typeof price === 'string' ? parseInt(price.split(',').join('')) : price})
            .then(res=>{
              if(res.data.url) 
              window.location.href = res.data.url
            }).catch(err=>{
              toast(`${t('Code')}  ${err.response?.data.error.code}  : ${err.response?.data.error.message}`,'error') 
            })
    }
    const dargahHandler = (select)=>{
        toast2.dismiss();
        setDargahSelected(select)
        
        if(select === 1 || select === 2){
          toast(t('This gateway is unavailable, use another one'),'error');
          (!price || price.length < 6) && toast(t('Control the price'),'error')
        }
        else
        if(!price || price.length < 6) toast(t('Control the price'),'error')
    }
    const optionPriceHandler = (val,select) => {
        setPrice(numToPrice(val))
        setSelected(select)
    }
    return(
        <div className='content payment'>
            <div className='input-parent'>
                <input
                    placeholder={t('Enter your consider price in rial')}
                    className='m10'
                    inputMode='numeric'
                    type='text'
                    maxLength='11'
                    onChange={(e)=> setPrice(e.target.value)}
                    value={price ? numToPrice(price): ''}
                    autoFocus={true}
                />
                <span className='inner-label'>{price && t('rial')}</span>
            </div>
            {(i18n.language === 'fa'|| i18n.language === 'ru') &&
            <div className='rial-to-toman text-center'>{(price  )&& `${Num2persian(parseInt(price.slice(0,-1)))} تومان` }</div>
            }
            {/* <div className='rial-to-toman text-center mt10'>{price && (price.length > 5) && `${numberToWords(parseInt(price.slice(0,-1)))} تومان`}</div> */}
            <div className='d-flex flex-column align-items-center space-between mt20 mr10 ml10 price-option'>
            <div className='text-center border-bottom ml10 mr10 mb10 pb5 fullWidth'>{t('Chosen price')}</div>
                <button className={`btn btn-circle pl10 pr10 ${selected === 0 && 'bold'} m5 price-btn`} 
                onClick={()=>optionPriceHandler(constant_pay,0)}> 
                <div>{t('Expert wage',{ amount : t('One')})}</div>
                <p>{numToPrice(constant_pay)} {t('rial')}</p>
                </button>
                <button className={`btn btn-circle pl10 pr10 ${selected === 1 && 'bold'} m5 price-btn`} 
                onClick={()=>optionPriceHandler(constant_pay*2,1) }>
                    <div>{t('Expert wage',{ amount : t('Two')})}</div>
                    <p>{numToPrice((constant_pay*2))} {t('rial')}</p>
                </button>
                
                <button className={`btn btn-circle pl10 pr10 ${selected === 2 && 'bold'} m5 price-btn`} 
                onClick={()=> optionPriceHandler(constant_pay*3,2)}>
                    <div>{t('Expert wage',{ amount : t('Three')})}</div>
                    <p>{numToPrice((constant_pay*3))} {t('rial')}</p>
                </button>
            </div>
            <div className='d-flex flex-column align-items-center dargah ml10 mr10 mt20 pl10 pr10 pt5'>
            <p className='border-bottom text-center pb10 pt10 fullWidth'>{t('Payment gateways')}</p>
            <div className='dargah-image'>
              <div className={`dargah-logo ${dargahSelect === 2 ? 'selected':'grey-img'}`} 
                onClick={()=> dargahHandler(2)}
                >
                <img src={SamanBank} alt="dargah" />
              </div>
              <div className={`dargah-logo ${dargahSelect === 1 ? 'selected':'grey-img'}`} 
                onClick={()=> dargahHandler(1)}
              >
                <img src={MeliBank} alt ="dargah"/>
              </div>
              <div className={`dargah-logo ${dargahSelect === 0 ? 'selected':'grey-img'}`} 
                onClick={()=> dargahHandler(0)}
                >
                <img src={ZarinPal} alt="dargah"/>
              </div>
            </div>
            <button className='btn btn-block btn-green btn-circle mb10' 
            onClick={handlerPay}
            disabled={(!price || price.length < 6) || dargahSelect !== 0}
            >
              {t('Pay')}
            </button>
          </div>
        </div>
    )
}